import { ReusableRouteTabs } from "../../Utils/Dialogs/ReusableTabs";
import React, { useEffect, useState } from "react";
import PageTitle from "../../Utils/smsTitle";
import { SubHeader } from "../../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVials, faPlus, faEdit, faBan } from "@fortawesome/free-solid-svg-icons";
import CustomTable from "../../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import { Link } from "react-router-dom";
import { LoadingGif } from "../../Utils/Loader";
import axios from "axios";
import { config } from "../../../Helpers/env";
import { logoutErrorMessage } from "../../../Helpers/ErrorMessages";
import { formatDigits } from "../../Utils/formatNumbers";
import { ReusableNewCOA } from "../ChartofAccounts/NewCOAccount";
import { history } from "../../../Helpers/history";
import { Container } from "../../Utils/styledComponents";

const headData = [
  { id: "count", numeric: false, disablePadding: false, label: "Sl" },
  { id: "accountname", numeric: false, disablePadding: false, label: "Account Name" },
  { id: "category_name", numeric: false, disablePadding: false, label: "Account Category" },
  { id: "parent_acct_name", numeric: false, disablePadding: false, label: "Account Detail" },
  { id: "account_balance", numeric: false, disablePadding: false, label: "Account Balance" },
  { id: "action", numeric: false, disablePadding: false, label: "Action", align: "center" }
];

const AccountsList = (props) => {
  const { actions } = props;
  const [isSubmittedItem, setIsSubmittedItem] = useState("idle");
  const [openAccount, setopenAccount] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [account_id, setaccount_id] = useState("");
  const [loading, setLoading] = useState("idle");
  const [accountList, setList] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [total_count, setCount] = useState(0);

  // ===== FILTERS =====
  const [categoryId, setCategoryId] = useState("");
  const [parentId, setParentId] = useState("");
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [parentOptions, setParentOptions] = useState([]);

  // 1. Load filter options only once
  useEffect(() => {
    const loadFilterOptions = async () => {
      try {
        const formData = new FormData();
        formData.append("page", 1);
        formData.append("per_page", 2000);

        const res = await axios.post(
          `${config.smsUrl}/accounting/accounts/list`,
          formData
        );

        const arr = res.data?.data?.accounts || [];

        const cats = [];
        const parents = [];
        const seenCat = new Set();
        const seenParent = new Set();

        arr.forEach((item) => {
          if (item.categoryid && !seenCat.has(item.categoryid)) {
            seenCat.add(item.categoryid);
            cats.push({ id: item.categoryid, name: item.category_name });
          }
          if (item.parent_id && item.parent_acct_name && !seenParent.has(item.parent_id)) {
            seenParent.add(item.parent_id);
            parents.push({ id: item.parent_id, name: item.parent_acct_name });
          }
        });

        cats.sort((a, b) => a.name.localeCompare(b.name));
        parents.sort((a, b) => a.name.localeCompare(b.name));

        setCategoryOptions(cats);
        setParentOptions(parents);
      } catch (err) {
        console.error("Failed to load filter options", err);
      }
    };

    loadFilterOptions();
  }, []);

  // 2. MAIN DATA FETCH (this was missing)
  useEffect(() => {
    setLoading("pending");

    const formData = new FormData();
    formData.append("search", searchValue);
    formData.append("page", activePage);
    formData.append("per_page", 100);          // ← limit per page

    if (categoryId) formData.append("category_id", categoryId);
    if (parentId) formData.append("parent_id", parentId);

    axios
      .post(`${config.smsUrl}/accounting/accounts/list`, formData)
      .then((res) => {
        const data = res.data;
        const dt = data?.data || {};
        const arr = dt.accounts || [];
        const count = dt.total_count || 0;

        setLoading("success");
        setCount(count);
        setList(arr);
      })
      .catch((err) => {
        logoutErrorMessage(err, null, actions);
        setLoading("error");
        setList([]);
      });
  }, [activePage, searchValue, categoryId, parentId, isSubmittedItem]);

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
    setActivePage(1);
  };

  const handleChangePage = (page) => {
    setActivePage(page);
  };

  const handleEditAccount = (id) => {
    setaccount_id(id);
    setopenAccount(true);
  };

  const handleNewAccount = () => {
    setaccount_id("");
    setopenAccount(true);
  };

  const closeSnackbar = () => {
    actions.snackbarActions.hideSnackbar();
  };

  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const { openBar, type, message } = props.snackbars;

  const components = [
    { label: "Account List", path: "/accounting/accounts/list" },
    { label: "Chart of Accounts", path: "/accounting/coa" }
  ];

  return (
    <div data-testid="lab-stock-list" className="journals">
      <PageTitle title="Chart Of Accounts List" />
      <SubHeader title="Chart Of Accounts" subTitle="Accounts">
        <FontAwesomeIcon icon={faVials} />
      </SubHeader>

      <ReusableNewCOA
        {...{
          actions,
          isSubmitted: isSubmittedItem,
          openDialog: openAccount,
          setIsSubmitted: setIsSubmittedItem,
          setOpenDialog: setopenAccount,
          account_id: account_id
        }}
      />

      <Container className="mt-1">
        <ReusableRouteTabs
          value={history.location.pathname}
          tabHeading={components}
        />

        <MainSnackbar
          variant={type}
          open={openBar}
          message={message}
          handleCloseBar={closeSnackbar}
        />

        {/* ===== FILTERS + NEW ACCOUNT ===== */}
        <div style={{ padding: "8px 0 0 0" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
              marginBottom: "14px"
            }}
          >
            {/* Account Type */}
            <select
              className="form-control form-control-sm"
              value={categoryId}
              onChange={(e) => {
                setCategoryId(e.target.value);
                setParentId("");
                setActivePage(1);
              }}
              style={{
                width: "180px",
                height: "32px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            >
              <option value="">All Account Types</option>
              {categoryOptions.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.name}
                </option>
              ))}
            </select>

            {/* Account Detail */}
            <select
              className="form-control form-control-sm"
              value={parentId}
              onChange={(e) => {
                setParentId(e.target.value);
                setActivePage(1);
              }}
              style={{
                width: "240px",
                height: "32px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            >
              <option value="">All Account Details</option>
              {parentOptions.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>

            <div style={{ flex: 1 }} />

            {/* New Account */}
            <button
              type="button"
              onClick={handleNewAccount}
              className="btn btn-sm text-white"
              style={{
                backgroundColor: "#389081",
                borderColor: "#389081",
                height: "32px",
                padding: "0 14px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            >
              <FontAwesomeIcon icon={faPlus} className="me-1" />
              New Account
            </button>
          </div>
        </div>

        {/* TABLE */}
        <div className="mui-tables">
          <CustomTable
            title="Accounts List"
            term={searchValue}
            records={100}
            activePage={activePage}
            headData={headData}
            handler={handleSearch}
            total_count={total_count}
            data={accountList}
            colSpan={headData.length}
            handleChangeNextPage={handleChangePage}
            customPage
            searchPlaceHolder="Search account name..."
          >
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    <LoadingGif />
                  </TableCell>
                </TableRow>
              ) : null}

              {isSuccess ? (
                accountList.length > 0 ? (
                  <>
                    {accountList.map((item, index) => {
                      const count = (activePage - 1) * 100 + index + 1;
                      return (
                        <TableRow hover key={item.id}>
                          <TableCell style={{ fontSize: "13px" }}>{count}</TableCell>
                          <TableCell style={{ fontSize: "13px" }}>
                            <Link
                              to={{
                                pathname: `/accounting/view-transactions/${item.id}/${item.head_code}-${item.accountname}`
                              }}
                              style={{
                                fontWeight: 600,
                                textDecoration: "none",
                                // color: "#027a5f"
                              }}
                            >
                              {item.accountname}
                            </Link>
                          </TableCell>
                          <TableCell style={{ fontSize: "13px" }}>
                            {item.category_name || "-"}
                          </TableCell>
                          <TableCell style={{ fontSize: "13px" }}>
                            {item.parent_acct_name || "-"}
                          </TableCell>
                          <TableCell style={{ fontSize: "13px", fontWeight: 600 }}>
                            {formatDigits(item.account_balance)}
                          </TableCell>
                          <TableCell align="center">
                            <button
                              type="button"
                              onClick={() => handleEditAccount(item.id)}
                              className="btn btn-sm text-white me-1"
                              style={{
                                backgroundColor: "#389081",
                                borderColor: "#389081",
                                height: "28px",
                                padding: "0 10px",
                                fontSize: "12px",
                                borderRadius: "5px"
                              }}
                            >
                              <FontAwesomeIcon icon={faEdit} className="me-1" />
                              Edit
                            </button>
                            <button
                              type="button"
                              onClick={() => console.log("deactivate", item.id)}
                              className="btn btn-sm"
                              style={{
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #ddd",
                                color: "#6c757d",
                                height: "28px",
                                padding: "0 10px",
                                fontSize: "12px",
                                borderRadius: "5px"
                              }}
                            >
                              <FontAwesomeIcon icon={faBan} className="me-1" />
                              Deactivate
                            </button>
                          </TableCell>
                        </TableRow>
                      );
                    })}

                    <TableRow>
                      <TableCell
                        colSpan={headData.length}
                        align="right"
                        style={{ fontSize: "13px", paddingTop: "12px" }}
                      >
                        <strong>Total Accounts: {total_count}</strong>
                      </TableCell>
                    </TableRow>
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={headData.length} align="center">
                      No records found
                    </TableCell>
                  </TableRow>
                )
              ) : null}

              {isError ? (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    The server did not return a valid response
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </CustomTable>
        </div>
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbar };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountsList);